import { DatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { ModelSavingData } from "src/hooks/use-model-saving-data";

export type TruxDateFieldProps<T> = {
  modelSavingData: ModelSavingData<T>,
  field: keyof T,
  label?: string,
  disabled?: boolean,
  limitWidth?: boolean,
  onChange?: (a: T) => void
}

export default function TruxDateField<T>({ modelSavingData, field, disabled = false, label, limitWidth = true, onChange }: TruxDateFieldProps<T>) {
  const value = modelSavingData.model?.[field];
  return <DatePicker
    label={label}
    value={!value ? null : dayjs(modelSavingData.model?.[field] as any)}
    onChange={(date: Dayjs | null) => {
      modelSavingData.update(model => {
        model[field] = date?.format("YYYY-MM-DD") as any;
        onChange?.(model);
      })
    }}
    disabled={disabled}
    slotProps={{
      textField: {
        fullWidth: true,
        size: "small"
      },
    }}
    sx={{
      maxWidth: limitWidth ? { md: 180 } : undefined,
      width: "100%"
    }}
  />
}